import { FormatSummaryTextEventArgs as FormatSummaryTextEventArgs_internal } from "./FormatSummaryTextEventArgs";
var IgrFormatSummaryTextEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrFormatSummaryTextEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrFormatSummaryTextEventArgs.prototype.createImplementation = function () {
        return new FormatSummaryTextEventArgs_internal();
    };
    Object.defineProperty(IgrFormatSummaryTextEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrFormatSummaryTextEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrFormatSummaryTextEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrFormatSummaryTextEventArgs.prototype, "field", {
        /**
         * Gets the summary property name.
        */
        get: function () {
            return this.i.c;
        },
        set: function (v) {
            this.i.c = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrFormatSummaryTextEventArgs.prototype, "displayName", {
        /**
         * Gets the summary display name.
        */
        get: function () {
            return this.i.b;
        },
        set: function (v) {
            this.i.b = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrFormatSummaryTextEventArgs.prototype, "summaryResult", {
        /**
         * Gets the original value before formatting.
        */
        get: function () {
            return this.i.a;
        },
        set: function (v) {
            this.i.a = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrFormatSummaryTextEventArgs.prototype, "formattedResult", {
        /**
         * Gets or sets the summary value as formatted text.  Setting this property will only affect summary cells.
        */
        get: function () {
            return this.i.d;
        },
        set: function (v) {
            this.i.d = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrFormatSummaryTextEventArgs.prototype, "formattedText", {
        /**
         * Gets or sets the final text that will be displayed in the group header.
        */
        get: function () {
            return this.i.e;
        },
        set: function (v) {
            this.i.e = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrFormatSummaryTextEventArgs;
}());
export { IgrFormatSummaryTextEventArgs };
//# sourceMappingURL=igr-format-summary-text-event-args.js.map
